<h5 class="section-title">Datos Personales</h5>
<div class="columns is-multiline">
  @if (miembro().associatedClientName) {
    <app-constitution-readonly-field label="Cliente" [value]="miembro().associatedClientName" colSize="6" />
  }
  <app-constitution-readonly-field label="Nombre apellidos / Razón social" [value]="miembro().nombre" colSize="6" />
  <app-constitution-readonly-field label="NIF" [value]="miembro().nif" colSize="6" />
  <app-constitution-readonly-field label="Domicilio completo" [value]="miembro().domicilio" colSize="6" />
</div>

@if ((miembro().representatives?.length ?? 0) > 0) {
  <table class="styled-table" style="margin-top: 0.5rem;" aria-label="Representantes del miembro">
    <thead>
      <tr>
        <th scope="col">Representante</th>
        <th scope="col">NIF</th>
      </tr>
    </thead>
    <tbody>
      @for (rep of miembro().representatives; track rep.name + rep.nif) {
        <tr>
          <td>{{ rep.name }}</td>
          <td>{{ rep.nif || '—' }}</td>
        </tr>
      }
    </tbody>
  </table>
}

@if (showCargoSection()) {
  <h5 class="section-title">Cargo</h5>
  <div class="columns is-multiline">
    <app-constitution-readonly-field label="Cargo" [value]="miembro().cargo" colSize="6" />
    <app-constitution-readonly-field label="Fecha alta cargo" [value]="miembro().fechaAlta" colSize="3" />
    <app-constitution-readonly-field label="Fecha baja cargo" [value]="miembro().fechaBaja" colSize="3" />
    <app-constitution-readonly-field
      label="Consejero delegado"
      [value]="formatYesNo(miembro().isCeo)"
      colSize="12"
    />
    @if (miembro().isCeo) {
      <app-constitution-readonly-field label="Fecha alta" [value]="miembro().ceoStartDate" colSize="3" />
      <app-constitution-readonly-field label="Fecha baja" [value]="miembro().ceoEndDate" colSize="3" />
    }
  </div>
}

@if (miembro().hasRetribution) {
  <h5 class="section-title">Retribución</h5>
  <div class="columns is-multiline">
    <app-constitution-readonly-field
      label="Clave de retribución"
      [value]="retributionKeysLabel()"
      colSize="12"
    />
    @if (miembro().retributionAmountA != null) {
      <app-constitution-readonly-field
        label="Importe retribución clave A"
        [value]="formatEuro(miembro().retributionAmountA)"
        colSize="4"
      />
    }
    @if (miembro().retributionAmountE != null) {
      <app-constitution-readonly-field
        label="Importe retribución clave E"
        [value]="formatEuro(miembro().retributionAmountE)"
        colSize="4"
      />
    }
    @if (miembro().retributionAmountG != null) {
      <app-constitution-readonly-field
        label="Importe retribución clave G"
        [value]="formatEuro(miembro().retributionAmountG)"
        colSize="4"
      />
    }
    <app-constitution-readonly-field
      label="Consta en estatutos"
      [value]="formatYesNo(miembro().inStatutes)"
      colSize="3"
    />
    <app-constitution-readonly-field
      label="Contrato"
      [value]="formatYesNo(miembro().hasContract)"
      colSize="3"
    />
    <app-constitution-readonly-field
      label="Acta"
      [value]="formatYesNo(miembro().hasMinutes)"
      colSize="3"
    />
    <app-constitution-readonly-field
      label="Fecha de inicio"
      [value]="miembro().retributionStartDate"
      colSize="3"
    />
  </div>
}

<h5 class="section-title">Datos Laborales</h5>
<div class="columns is-multiline">
  <app-constitution-readonly-field
    label="Régimen de la Seguridad Social"
    [value]="miembro().socialSecurityRegime"
    colSize="6"
  />
  <app-constitution-readonly-field label="Encuadramiento" [value]="miembro().classification" colSize="6" />
  <app-constitution-readonly-field
    label="Autónomos a Cargo de"
    [value]="miembro().selfEmployedChargedTo"
    colSize="6"
  />
  @if (miembro().selfEmployedChargedName) {
    <app-constitution-readonly-field label="Persona" [value]="miembro().selfEmployedChargedName" colSize="6" />
  }
  <app-constitution-readonly-field label="IBAN (en Seguridad Social)" [value]="miembro().iban" colSize="6" />
  <app-constitution-readonly-field
    label="Rendimiento Neto Mensual"
    [value]="monthlyIncomeLabel()"
    colSize="6"
  />
  <app-constitution-readonly-field
    label="Mutua ACC: Trabajo/EP"
    [value]="miembro().mutualAccidents"
    colSize="6"
  />
  <app-constitution-readonly-field
    label="Mutua CC / IT"
    [value]="miembro().mutualCommonContingencies"
    colSize="6"
  />
</div>

<h5 class="section-title">Firmas</h5>
<div class="columns is-multiline">
  <app-constitution-readonly-field label="Firma las CCAA" [value]="formatYesNo(miembro().signsCCAA)" colSize="4" />
  <app-constitution-readonly-field label="Certifica las CCAA" [value]="formatYesNo(miembro().certifiesCCAA)" colSize="4" />
  <app-constitution-readonly-field label="Firma el IS" [value]="formatYesNo(miembro().signsIS)" colSize="4" />
  <app-constitution-readonly-field label="Certifica el IS" [value]="formatYesNo(miembro().certifiesIS)" colSize="4" />
  <app-constitution-readonly-field
    label="Firma contratos laborales"
    [value]="formatYesNo(miembro().signsLaborContracts)"
    colSize="4"
  />
  <app-constitution-readonly-field
    label="Firma documentos laborales"
    [value]="formatYesNo(miembro().signsLaborDocuments)"
    colSize="4"
  />
</div>

<div class="columns is-multiline">
  <app-constitution-readonly-field
    label="Observaciones"
    [value]="miembro().observations"
    colSize="12"
    [multiline]="true"
  />
</div>
